import { RegistrarTaskState } from './state';
import { apiUrl } from '@/env';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { IRegistrarTask, IRegistrarOneTaskStat, IRegistrarTasksStatData } from '@/interfaces/registrar';


export const mutations = {
  setRegistrarTasks(state: RegistrarTaskState, payload: IRegistrarTask[]) {
    // добавляем флаг isExporting; его пока нет в PG
    // если isExporting = true, иконка загрузки файлов заблокирована
    payload.forEach((item) => {
      item.isExporting = state.tasks.find((task) => task.id === item.id)?.isExporting;
      item.isDownloading = state.tasks.find((task) => task.id === item.id)?.isDownloading;
      if (item.status === 'ACTIVE') {
        const taskActive = state.tasks.find((t) => t.id === item.id);
        if (taskActive && taskActive.stats) item.stats = taskActive.stats;
      }
      if (item.isExporting) item.status = 'EXPORT';
      else if (item.isDownloading) item.status = 'DOWNLOAD';
    });
    state.tasks = payload;
  },
  setRegistrarTask(state: RegistrarTaskState, payload: IRegistrarTask) {

    // const newList: IRegistrarTask[] = state.yt_tasks.slice();
    // const index = newList.findIndex(item => item.id === payload.id);
    // if (index !== -1) {
    //     newList[index] = payload;
    //     state.yt_tasks = newList;
    // };

    // самый быстрый вариант
    const newList: IRegistrarTask[] = state.tasks.slice();
    for (let i = 0; i < newList.length; i++)
      if (newList[i].id === payload.id) {
        newList[i] = payload;
        break;
      }
    state.tasks = newList;
  },

  // изменяем флаг isExporting
  setRegistrarTaskIsExporting(state: RegistrarTaskState, payload: { id: number, isExporting: boolean}) {
      const task = state.tasks.find((item: IRegistrarTask) => item.id === payload.id);
      if (task) task.isExporting = payload.isExporting;
  },

  // изменяем флаг isDownloading
  setRegistrarTaskIsDownloading(state: RegistrarTaskState, payload: { id: number, isDownloading: boolean}) {
      const task = state.tasks.find((item: IRegistrarTask) => item.id === payload.id);
      if (task) task.isDownloading = payload.isDownloading;
  },

  setRegistrarTaskStatus(state: RegistrarTaskState, payload: { id: number, status: string}) {
      const task = state.tasks.find((item: IRegistrarTask) => item.id === payload.id);
      if (task) task.status = payload.status;
  },

  setRegistrarTasksStat(state: RegistrarTaskState, payload: IRegistrarTasksStatData) {
    if (payload.tasks)
      state.tasks = state.tasks.map((t: IRegistrarTask) => {
        const taskStat = payload.tasks.find((s: IRegistrarOneTaskStat) =>  t.id === s.task_id);
        if (taskStat) {
          t.status = taskStat.status;
          t.datetime_end = taskStat.datetime_end;

          const prev = t.stats?.prev;
          const prev_time = t.stats?.prev_time;

          t.stats = taskStat.stats;

          // записыаем стартовые значения количества найденных данных и времени
          // для расчета времени до завершения парсинга
          if (t.stats) {
            t.stats.prev = prev;
            t.stats.prev_time = prev_time;

            const curTime = new Date();

            if (t.stats.found_count > 0) {
              if (t.stats.prev === undefined)
                t.stats.prev = t.stats.found_count;

              if (t.stats.prev_time === undefined)
                t.stats.prev_time = curTime;
            }
          }

          if (taskStat.result)
            t.result = `${apiUrl}/api/v1/registrar-tasks/result/${taskStat.result}`;
        }
        return t;
      });
  },
};

const { commit } = getStoreAccessors<RegistrarTaskState, State>('');

export const commitSetRegistrarTask = commit(mutations.setRegistrarTask);
export const commitSetRegistrarTasks = commit(mutations.setRegistrarTasks);
export const commitSetRegistrarTasksStat = commit(mutations.setRegistrarTasksStat);
export const commitSetRegistrarTaskIsExporting = commit(mutations.setRegistrarTaskIsExporting);
export const commitSetRegistrarTaskIsDownloading = commit(mutations.setRegistrarTaskIsDownloading);
export const commitSetRegistrarTaskStatus = commit(mutations.setRegistrarTaskStatus);
